import __vue_normalize__ from 'vue-runtime-helpers/dist/normalize-component.mjs';
import HseDropdownMenuBaseItem from './HseDropdownMenuBaseItem.vue_rollup-plugin-vue=script.js';

/* script */
const __vue_script__ = HseDropdownMenuBaseItem;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g({ref:"root",staticClass:"hse-DropdownMenuBaseItem",class:{
    'hse-DropdownMenuBaseItem_selected': _vm.selected,
    'hse-DropdownMenuBaseItem_disabled': _vm.disabled,
    'hse-DropdownMenuBaseItem_hovered': _vm.hovered,
    'hse-DropdownMenuBaseItem_focused': _vm.focused
  },style:(_vm.rootStyle),attrs:{"title":_vm.title}},_vm.$listeners),[(_vm.$slots.left)?_c('div',{staticClass:"hse-DropdownMenuBaseItem__left"},[_vm._t("left")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"hse-DropdownMenuBaseItem__content"},[_vm._t("default")],2),_vm._v(" "),(_vm.$slots.right)?_c('div',{staticClass:"hse-DropdownMenuBaseItem__right"},[_vm._t("right")],2):_vm._e()])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
